export interface SrsBallotVoteType {
  key: string;
  name: string;
  order: number;
  color: string;
  value: number;
  percentage: number;
}

export interface SrsBallotResult {
  SVT_NONE: SrsBallotVoteType;
  SVT_RECONFIRM: SrsBallotVoteType;
  SVT_REVISE: SrsBallotVoteType;
  SVT_WITHDRAW: SrsBallotVoteType;
}

export const SrsBallotVoteTypes: SrsBallotResult = {
  SVT_NONE: {
    key: 'SVT_NONE',
    name: 'No Response',
    order: 4,
    color: '#fdb414',
    value: 0,
    percentage: 0,
  },
  SVT_RECONFIRM: {
    key: 'SVT_RECONFIRM',
    name: 'Reconfirm',
    order: 1,
    color: '#00c257',
    value: 0,
    percentage: 0,
  },
  SVT_REVISE: {
    key: 'SVT_REVISE',
    name: 'Revise',
    order: 2,
    color: '#2727df',
    value: 0,
    percentage: 0,
  },
  SVT_WITHDRAW: {
    key: 'SVT_WITHDRAW',
    name: 'Withdraw',
    order: 3,
    color: '#808080',
    value: 0,
    percentage: 0,
  },
};
